export class CampoSpecificoConservazioneVO {
  numeroAnni: number;
  termineRiferimento: string;
  dataRiferimento: string;
}
